import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import EntryMethods from "../../components/Tank/EntryMethods";
import Accounts from "../../components/Tank/Accounts";
import Contests from "../../components/Tank/Contests";
import Logins from "../../components/Tank/Logins";
import ThemesAndColors from "../../components/Tank/ThemesAndColors";
import Kv from "../../components/Tank/Kv";
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (<div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (<Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>)}
        </div>);
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function BasicTabs() {
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (<Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                    <Tab label="Accounts" {...a11yProps(0)} />
                    <Tab label="Contests" {...a11yProps(1)} />
                    <Tab label="Entry Types" {...a11yProps(2)} />
                    <Tab label="KV" {...a11yProps(3)} />
                    <Tab label="Logins" {...a11yProps(4)} />
                    <Tab label="Themes" {...a11yProps(5)} />
                    <Tab label="Colors" {...a11yProps(6)} />
                </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
                <Accounts />
            </TabPanel>
            <TabPanel value={value} index={1}>
                <Contests />
            </TabPanel>
            <TabPanel value={value} index={2}>
                <EntryMethods />
            </TabPanel>
            <TabPanel value={value} index={3}>
                <Kv />
            </TabPanel>
            <TabPanel value={value} index={4}>
                <Logins />
            </TabPanel>
            <TabPanel value={value} index={5}>
                <ThemesAndColors themes_or_colors={"styles"} />
            </TabPanel>
            <TabPanel value={value} index={6}>
                <ThemesAndColors themes_or_colors={"colors"} />
            </TabPanel>
        </Box>
    );
}
